import BadgeT from '@components/tailwind-components/Badge/BadgeT';
import type React from 'react';

interface LanguageBadgeProps {
  language: string;
}

export const LanguageBadge: React.FC<LanguageBadgeProps> = ({ language }) => (
  <BadgeT
    text={language.toUpperCase()}
    icon='translate'
    iconClasses='text-sm leading-none'
    bgColorHex='#f3f4f6'
    fontColorHex='#9ca3af'
    shouldOverrideTextSize
    className='text-pico !font-medium !z-auto'
  />
);
